<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- 加农正和简介到企业荣誉 -->

                <div class="productCenter">
                    <header>产品中心</header>
                    <footer>Product&nbsp;Center</footer>
                </div>
                <DaoTwo></DaoTwo>

        </el-tabs>
    </div>
</template>

<script>
import axios from "axios";
import DaoTwo from "./DaoTwo";
export default {
    name: "E",
    // data() {
    //     return {
    //         labelList: [121212, 212122, 3],
    //         activeName: "",
    //         goodsCateList: {},
    //         aboutList: {},
    //     };
    // },
    // methods: {
    //     async getGoodsCateList() {
    //         this.goodsCateList = (
    //             await axios({
    //                 method: "get",
    //                 url: "/xm/index.php/index/index/getGoodsCateList",
    //                 params: {
    //                     page: 1,
    //                     limit: 8,
    //                     cateid: 1,
    //                 },
    //             })
    //         ).data.data;
    //         console.log(this.goodsCateList);
    //     },
    //
    //     async getAboutList() {
    //         this.aboutList = (
    //             await axios({
    //                 method: "get",
    //                 url: "/xm/index.php/index/index/getAboutList",
    //                 params: {},
    //             })
    //         ).data.data;
    //         console.log(this.aboutList);
    //     },
    // },
    // created() {
    //     this.getAboutList();
    // },
    components: { DaoTwo },
};
</script>

<style scoped lang="less">
/deep/ .el-tabs__active-bar {
    background-color: #1EA364;
}
/deep/ .el-tabs__nav {
    margin: 0 auto;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0) !important;
}
/deep/ .el-tabs__item.is-active {
    color: #df5c62;
}

/deep/ .el-tabs__nav-scroll::after {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0) !important;
}
/deep/.productCenter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    header {
        text-align: center;
        height: 2.0833vw;
        font-size: 2.2917vw;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        color: #1EA364;
        margin-top: 4.1146vw;
        letter-spacing:0.15vw;
    }
    footer {
        text-align: center;
        height: 1.0417vw;
        font-size: 1.3542vw;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #646464;
        margin-top: 1.0417vw;
        margin-bottom: 6vw;
    }
}
</style>
